import { Badge } from "@/components/ui/badge";
import type { UserRole } from "@/api/types/user-management.types";
import { roleColors } from "@/config/user-menu.config";

interface UserRoleBadgesProps {
  roles: UserRole[];
  size?: "sm" | "md";
  className?: string;
}

/**
 * Reusable component to display user roles as colored badges
 * Used in UserDropdown menu and Profile page
 */
export const UserRoleBadges = ({
  roles,
  size = "sm",
  className = "",
}: UserRoleBadgesProps) => {
  if (!roles || roles.length === 0) return null;

  const sizeClasses = {
    sm: "text-[10px] px-1.5 py-0",
    md: "text-xs px-2 py-0.5",
  };

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {roles.map((role) => (
        <Badge
          key={role}
          variant="secondary"
          className={`font-medium border-0 ${sizeClasses[size]} ${roleColors[role] || ""}`}
        >
          {role}
        </Badge>
      ))}
    </div>
  );
};
